async function get(path: string) {
  const res = await fetch(path, { credentials: 'include' });
  return res.json().catch(() => null);
}

export function createWebSimApi() {
  return {
    getSimStats(simId: string) {
      return get(`/api/sim/${encodeURIComponent(simId)}`);
    },
    getAllSimStats() {
      return get('/api/sim');
    },
    getUsageForSim(simId: string) {
      return get(`/api/sim/${encodeURIComponent(simId)}/usage`);
    },
  };
}
